<template>
  <default-dialog ref="dialog"
                  :padded="false"
                  v-on="$listeners">
    <div class="message r-text-regular text-riseup-blue r-text-bold text-center">{{ statusMessage }}</div>
    <animated-loader />
  </default-dialog>
</template>

<script>
import GlobalDialog from '@/components/base/GlobalDialog';
import DefaultDialog from '@/components/styled/DefaultDialog';
import BaseUI from 'base-ui';

export default {
  name: 'SubmitInProgress',
  components: {
    DefaultDialog,
    AnimatedLoader: BaseUI.AnimatedLoader,
  },
  mixins: [GlobalDialog],
  props: {
    statusMessage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

.message {
  padding: 35px 75px;
}

img {
  width: 100%;
}

</style>
